// hooks
import { Fragment, useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";
import { useParams } from "react-router-dom";

// material styles
import { Grid, TextField, Button } from "@mui/material";

// components
import BackButton from "components/shared/BackButton";
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";

//  react icons
import { MdDownload } from "react-icons/md";

// styled component
import { StyledStack, StyledTitle, ButtonContainer } from "./catalog.style";

// request methods
import { getCatalogByIdRequest } from "api/requests/catalogs";

// constants
import { FILE_BASE_URL } from "constants";

export default function DisplayCatalog() {
  const { catalog_id } = useParams();

  const { request, loading, setLoading } = useHttp();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(),
  });

  // catalog file path state
  const [path, setPath] = useState("");

  // get catalog data by id
  const getCatalogByIdData = useCallback(async () => {
    const catalogRes = await request({
      url: () => getCatalogByIdRequest({ id: catalog_id }),
    });

    if (catalogRes) {
      let data = catalogRes.data;
      setPath(data.file);
      reset({
        full_name: data.user.full_name,
        phone_number: data.user.phone_number,
        company_name: data.company_name,
        type: data.post,
        email: data.user.email,
        description: data.description,
      });
    }

    setLoading(false);
  }, [setLoading]);

  useEffect(() => getCatalogByIdData(), [getCatalogByIdData]);

  return (
    <DrawerCM title="کاتالوگ">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/catalogs" />
            </Grid>
            <StyledStack>
              <Grid>
                <StyledTitle>نمایش کاتالوگ</StyledTitle>
                <Grid container>
                  <Grid item md={6} xs={12} p={1.5}>
                    <TextField
                      fullWidth
                      id="full_name"
                      label="نام و نام خانوادگی"
                      {...register("full_name")}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item md={6} xs={12} p={1.5}>
                    <TextField
                      id="phone_number"
                      label="شماره تلفن"
                      fullWidth
                      {...register("phone_number")}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item md={6} xs={12} p={1.5}>
                    <TextField
                      fullWidth
                      id="company_name"
                      label="نام شرکت"
                      {...register("company_name")}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item md={6} xs={12} p={1.5}>
                    <TextField
                      id="type"
                      fullWidth
                      label="سمت"
                      {...register("type")}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} p={1.5}>
                    <TextField
                      id="email"
                      fullWidth
                      label="ایمیل"
                      {...register("email")}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  {/* <ButtonContainer>
                    <Button
                      startIcon={<MdDownload size={22} />}
                      variant="contained"
                      sx={{ mt: 1 }}
                      onClick={() => {
                        window.open(`${FILE_BASE_URL}${path}`, "_blank");
                      }}
                    >
                      دانلود کاتالوگ
                    </Button>
                  </ButtonContainer> */}
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
